import { render } from "./ExercicesView.vue?vue&type=template&id=41f405c6&scoped=true"
import script from "./ExercicesView.vue?vue&type=script&lang=js"
export * from "./ExercicesView.vue?vue&type=script&lang=js"

import "./ExercicesView.vue?vue&type=style&index=0&id=41f405c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f405c6"]])

export default __exports__